import React from "react";
import { DotsLoader } from "@/components/common/Loader/DotsLoader";

import styles from "./BotLoadingMessage.module.css";

type Props = {};

export const BotLoadingMessage: React.FC<Props> = ({}) => {
  return (
    <div className={styles.container}>
      <div className={styles.bubble}>
        <DotsLoader />
      </div>
    </div>
  );
};
